import React, { useState, useEffect } from 'react';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { oneKlicks } from '../../SDK/oneclick';
import ImageShow from '../../Uitiles/ImageShow';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Form, Badge, Row, Col } from 'react-bootstrap';
import { useSearchParams } from "react-router-dom";
import { getuserdata } from '../../services/apiService';


import '../../assets/styles/FrameEditor.css';  // this css file only for this page

const FrameEditor = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [freameid, setFreameid] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchParams] = useSearchParams();
  const [savingmode, setSavingmode] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [frameData, setFrameData] = useState({
    title: '',
    description: '',
    category: '',
    status: 'publish',
    imageUrl: '',
    imageid: '',
    blowPrintUrl: '',
    blowPrintid: '',
    htmlCode: '',
    cssCode: '',
    svgCode: ''
  });
  const [previewMode, setPreviewMode] = useState('desktop');
  const [userdata, setUserdata] = useState(null);

  const categories = ['Modern', 'Classic', 'Vintage', 'Minimalist', 'Luxury', 'Creative'];

  useEffect(() => {
    console.log("searchParams", searchParams);
    const urlid = searchParams.get('id');
    console.log("searchParams urlid", urlid);
    if (urlid == null) {
      console.log("urlid", urlid);
      console.log("createFrameData");
      createFrameData();
    } else {
      setFreameid(searchParams.get('id'));
      console.log("searchParams urlid", urlid);
      console.log("searchParams getFrameData");
      getFrameData();
    }
    getUserdata();
  }, []);

  const getUserdata = async () => {
    const userdata = await getuserdata("full");
    setUserdata(userdata);
    console.log("userdata", userdata);
  }

  const getFrameData = async () => {
    try {
      const tableSchema = "";
      const tableName = "postframes";
      const conditions = {
        frameid: searchParams.get('id'),
      }
      const orderBy = "id DESC";
      const search = {};
      const pagination = {
        page: 1,
        limit: 1,
      }
      const margedata = [];
      const frameData = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log("searchParams frameData", frameData);
      if (frameData.success) {
        setFrameData(
          {
            title: frameData.data[0].title || '',
            description: frameData.data[0].description || '',
            category: frameData.data[0].category || '',
            status: frameData.data[0].status || '',
            imageUrl: frameData.data[0].imageUrl || '',
            imageid: frameData.data[0].imageid || '',
            blowPrintUrl: frameData.data[0].blowPrintUrl || '',
            blowPrintid: frameData.data[0].blowPrintid || '',
            htmlCode: frameData.data[0].htmlCode || '',
            cssCode: frameData.data[0].cssCode || '',
            svgCode: frameData.data[0].svgCode || '',
          }
        );
      } else {
        setFreameid(null);
      }
    } catch (error) {
      console.error('Error getting frame data:', error);
      setFreameid(null);
    }
  }

  const createFrameData = async () => {
    try {
      const freameidlocal = Date.now();
      const tableSchema = "";
      const tableName = "postframes";
      const data = {
        frameid: freameidlocal,
        title: 'new frame',
      }
      const conditions = {
        frameid: freameidlocal,
      }
      const frameData = await oneKlicks.create(tableSchema, tableName, data, conditions);
      console.log("frameData", frameData);
      if (frameData.success) {
        setFreameid(freameidlocal);
        // update url
        navigate(`/admin/frame-editor?id=${freameidlocal}`);
      } else {
        setFreameid(null);
      }
    } catch (error) {
      console.error('Error getting frame data:', error);
      setFreameid(null);
    }
  }

  useEffect(() => {
    // Initialize with default code
    setFrameData(prev => ({
      ...prev,
      htmlCode: `<div class="frame-container">
  <div class="frame-content">
    <h1>Your Frame Title</h1>
    <p>Add your content here</p>
  </div>
</div>`,
      cssCode: `.frame-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.frame-content {
  text-align: center;
  color: white;
}

.frame-content h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.frame-content p {
  font-size: 1.2rem;
  opacity: 0.9;
}`,
      svgCode: `<svg width="100%" height="100%" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
    </linearGradient>
  </defs>
  <rect width="100%" height="100%" fill="url(#bg)" rx="10"/>
  <text x="400" y="300" text-anchor="middle" fill="white" font-size="48" font-family="Arial">Your SVG Content</text>
</svg>`
    }));
  }, []);

  const handleFileSelect = async (event, type) => {
    const file = event.target.files[0];
    if (file) {
      setUploading(true);
      try {
        const upload = await OneKlicksFileSDK.uploadFile(
          'frames',
          "public",
          file
        );

        if (upload.success === true) {
          const fileUrl = `${upload.file.root}/${upload.file.fileName}`;
          const fileId = upload.fileId;

          setFrameData(prev => ({
            ...prev,
            [type === 'image' ? 'imageUrl' : 'blowPrintUrl']: fileUrl,
            [type === 'image' ? 'imageid' : 'blowPrintid']: fileId
          }));

          setSelectedFile(file);
        }
      } catch (error) {
        console.error('Upload error:', error);
        alert(`Upload failed: ${error.message}`);
      } finally {
        setUploading(false);
      }
    }
  };

  const saveFrame = async () => {
    if (!frameData.title.trim()) {
      alert('Please enter a title');
      return;
    }



    setLoading(true);
    try {
      const tableSchema = "";
      const tableName = "postframes";
      const data = {
        ...frameData
      };
      const conditions = {
        frameid: searchParams.get('id'),
      };

      const result = await oneKlicks.update(tableSchema, tableName, data, conditions);

      if (result.error) {
        throw new Error(result.error);
      }

      alert('Frame saved successfully!');
      navigate('/admin/frames');
    } catch (error) {
      console.error('Save error:', error);
      alert(`Save failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const updateFrameData = async (value, type) => {
    try {
      setFrameData(prev => ({ ...prev, [type]: value }));
      const tableSchema = "";
      const tableName = "postframes";
      const data = {
        [type]: value
      }
      const conditions = {
        frameid: freameid,
      }
      const updateResult = await oneKlicks.update(tableSchema, tableName, data, conditions);
      if (updateResult.error) {
        throw new Error(updateResult.error);
      }
    } catch (error) {
      console.error('Update error:', error);
      alert(`Update failed: ${error.message}`);
    }
  }

  // Function to process CSS and replace specific image URLs based on class names
  const processCSSWithDynamicURLs = (cssCode, imageReplacements = {}) => {
    if (!cssCode) return cssCode;
    
    // Replace hardcoded background URLs with dynamic placeholders or actual dynamic URLs
    let processedCSS = cssCode;
    
    // Default image replacements if none provided
    const defaultReplacements = {
      'drimage-f746e7015907': userdata?.profile_photo_url ? 
        (userdata.profile_photo_url.startsWith('http') ? userdata.profile_photo_url : `${process.env.REACT_APP_API_BASE_URL}${userdata.profile_photo_url}`) :
        'https://via.placeholder.com/87x87/667eea/ffffff?text=Doctor+Image',
      'mainimage': frameData.imageUrl ? 
        (frameData.imageUrl.startsWith('http') ? frameData.imageUrl : `${process.env.REACT_APP_API_BASE_URL}${frameData.imageUrl}`) :
        'https://via.placeholder.com/512x512/667eea/ffffff?text=Main+Image',
      'drlogo': frameData.blowPrintUrl ? 
        (frameData.blowPrintUrl.startsWith('http') ? frameData.blowPrintUrl : `${process.env.REACT_APP_API_BASE_URL}${frameData.blowPrintUrl}`) :
        'https://via.placeholder.com/150x37/667eea/ffffff?text=Logo',
      'qrcode': 'https://via.placeholder.com/50x50/ffffff/000000?text=QR'
    };
    
    // Merge provided replacements with defaults
    const replacements = { ...defaultReplacements, ...imageReplacements };
    
    // Debug: Log the original CSS and replacements
    console.log('Original CSS:', cssCode);
    console.log('Image replacements:', replacements);
    
    // Process each replacement
    Object.keys(replacements).forEach(className => {
      const replacementUrl = replacements[className];
      
      // Pattern to match specific class with background URL
      const classPattern = new RegExp(`\\.${className}-[^{]*\\{[^}]*background:\\s*url\\([^)]+\\)[^}]*\\}`, 'gi');
      
      processedCSS = processedCSS.replace(classPattern, (match) => {
        // Preserve all other properties but replace only the background URL
        return match.replace(/background:\s*url\([^)]+\)/gi, `background: url(${replacementUrl})`);
      });
      
      // Also handle individual class background declarations
      const classBackgroundPattern = new RegExp(`(\\.${className}-[^{]*\\{[^}]*?)background:\\s*url\\([^)]+\\)([^}]*\\})`, 'gi');
      processedCSS = processedCSS.replace(classBackgroundPattern, (match, before, after) => {
        return `${before}background: url(${replacementUrl})${after}`;
      });
    });
    
    // Debug: Log the processed CSS
    console.log('Processed CSS:', processedCSS);
    
    return processedCSS;
  };

  // Helper function to replace specific image URLs
  const replaceImageUrl = (className, newUrl) => {
    const customReplacements = {
      [className]: newUrl
    };
    return processCSSWithDynamicURLs(frameData.cssCode, customReplacements);
  };

  const renderPreview = () => {
    // You can pass custom image replacements here
    const customReplacements = {
      // Example: 'mainimage': 'https://your-custom-url.com/image.jpg',
      // Example: 'drimage': 'https://your-custom-url.com/doctor.jpg',
      'drimage': userdata?.profile_photo_url ? 
        (userdata.profile_photo_url.startsWith('http') ? userdata.profile_photo_url : `${process.env.REACT_APP_API_BASE_URL}${userdata.profile_photo_url}`) :
        'https://via.placeholder.com/87x87/667eea/ffffff?text=Doctor+Image',
      'mainimage': frameData.imageUrl ? 
        (frameData.imageUrl.startsWith('http') ? frameData.imageUrl : `${process.env.REACT_APP_API_BASE_URL}${frameData.imageUrl}`) :
        'https://via.placeholder.com/512x512/667eea/ffffff?text=Main+Image',
      'drlogo': frameData.blowPrintUrl ? 
        (frameData.blowPrintUrl.startsWith('http') ? frameData.blowPrintUrl : `${process.env.REACT_APP_API_BASE_URL}${frameData.blowPrintUrl}`) :
        'https://via.placeholder.com/150x37/667eea/ffffff?text=Logo',
      'qrcode': 'https://via.placeholder.com/50x50/ffffff/000000?text=QR'
    };
    
    const processedCSS = processCSSWithDynamicURLs(frameData.cssCode, customReplacements);
    
    return (
      <div
        className="preview-container"
        style={{
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '8px',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <style>{processedCSS}</style>
        {/* <style>{frameData.cssCode}</style> */}
        <div dangerouslySetInnerHTML={{ __html: frameData.htmlCode }} />
        {frameData.svgCode && (
          <div dangerouslySetInnerHTML={{ __html: frameData.svgCode }} />
        )}
      </div>
    );
  };

  return (
    <div className="frame-editor">
      {/* Page Header */}
      <div className="dc-haslayout dc-dbsectionspace">
        <div className="container-fluid py-3">
          <div className="card mb-3">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                 <div className="d-flex align-items-center gap-3">
                   <div className="d-flex align-items-center gap-2">
                     <h4 className="mb-0 font-weight-bold mr-3">Frame Editor</h4>
                     <Badge bg="info">Create frame templates with HTML, CSS & SVG</Badge>
                   </div>
                 </div>
                 <div className="d-flex align-items-center gap-2">
                   
                   <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                     <Button
                       variant="outline-primary"
                       onClick={() => setPreviewMode(previewMode === 'desktop' ? 'mobile' : 'desktop')}
                     >
                       {previewMode === 'desktop' ? '📱 Mobile' : '🖥️ Desktop'}
                     </Button>
                     <Button
                       variant="success"
                       onClick={() => setShowInfoModal(true)}
                       disabled={loading || savingmode}
                     >
                       {loading ? 'Saving...' : searchParams.get('id') ? 'Update Frame' : 'Save Frame'}
                     </Button>
                   </div>
                 </div>
               </div>
             </div>
           </div>

          {/* Main Content */}
          <div className="card">
            <div className="card-body">
              <Row className="g-3">
                {/* Left Side Panel */}
                <Col lg={6}>
                  <div className="left-panel">

                    {/* HTML Code Editor */}
                    <Card className="mb-3">
                      <Card.Header>
                        <h6 className="mb-0">HTML Code</h6>
                      </Card.Header>
                      <Card.Body>
                        <Form.Control
                          as="textarea"
                          rows={8}
                          className="html-code-editor"
                          value={frameData.htmlCode}
                          onChange={(e) => {
                            setFrameData(prev => ({ ...prev, htmlCode: e.target.value }))
                            updateFrameData(e.target.value, 'htmlCode');
                          }}
                          placeholder="Enter your HTML code here..."
                          style={{ fontFamily: 'monospace', fontSize: '12px', width: '100%', height: '300px' }}
                        />
                      </Card.Body>
                    </Card>

                    {/* CSS Code Editor */}
                    <Card className="mb-3">
                      <Card.Header>
                        <h6 className="mb-0">CSS Code</h6>
                      </Card.Header>
                      <Card.Body>
                        <Form.Control
                          as="textarea"
                          rows={8}
                          className="css-code-editor"
                          value={frameData.cssCode}
                          onChange={(e) => {
                            setFrameData(prev => ({ ...prev, cssCode: e.target.value }))
                            updateFrameData(e.target.value, 'cssCode');
                          }}
                          placeholder="Enter your CSS code here..."
                          style={{ fontFamily: 'monospace', fontSize: '12px', width: '100%', height: '300px' }}
                        />
                      </Card.Body>
                    </Card>

                    {/* SVG Code Editor */}
                    <Card>
                      <Card.Header>
                        <h6 className="mb-0">SVG Code</h6>
                      </Card.Header>
                      <Card.Body>
                        <Form.Control
                          as="textarea"
                          rows={8}
                          className="svg-code-editor"
                          value={frameData.svgCode}
                          onChange={(e) => {
                            setFrameData(prev => ({ ...prev, svgCode: e.target.value }))
                            updateFrameData(e.target.value, 'svgCode');
                          }}
                          placeholder="Enter your SVG code here..."
                          style={{ fontFamily: 'monospace', fontSize: '12px', width: '100%', height: '300px' }}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </Col>

                {/* Right Side Preview */}
                <Col lg={6}>
                  <Card>
                    <Card.Header>
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0">Live Preview</h6>
                        <div className="d-flex gap-2">
                          <Badge bg="info">{previewMode === 'desktop' ? 'Desktop' : 'Mobile'}</Badge>
                          <Badge bg="secondary">Live</Badge>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                      <div className="preview-wrapper">
                        {renderPreview()}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>


       {/* Frame Info Modal */}
       {showInfoModal && (
         <div className="modal-overlay">
           <div className="modal"  style={{ display: showInfoModal ? 'block' : 'none', marginLeft: 'auto', marginRight: 'auto' }}>
             <div className="modal-header">
               <h2>Frame Information</h2>
               <button 
                 className="btn-close"
                 onClick={() => setShowInfoModal(false)}
               >
                 ×
               </button>
             </div>
             <div className="modal-body">
               <Form.Group className="mb-3">
                 <Form.Label>Title *</Form.Label>
                 <Form.Control
                   type="text"
                   value={frameData.title}
                   onChange={(e) => {
                     setFrameData(prev => ({ ...prev, title: e.target.value }));
                     updateFrameData(e.target.value, 'title');
                   }}
                   placeholder="Enter frame title"
                 />
               </Form.Group>
               <Form.Group className="mb-3">
                 <Form.Label>Description</Form.Label>
                 <Form.Control
                   as="textarea"
                   rows={3}
                   value={frameData.description}
                   onChange={(e) => {
                     setFrameData(prev => ({ ...prev, description: e.target.value }));
                     updateFrameData(e.target.value, 'description');
                   }}
                   placeholder="Enter frame description"
                 />
               </Form.Group>
               <Form.Group className="mb-3">
                 <Form.Label>Category</Form.Label>
                 <Form.Select
                   value={frameData.category}
                   onChange={(e) => {
                     setFrameData(prev => ({ ...prev, category: e.target.value }));
                     updateFrameData(e.target.value, 'category');
                   }}
                 >
                   <option value="">Select category</option>
                   {categories.map(cat => (
                     <option key={cat} value={cat}>{cat}</option>
                   ))}
                 </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                 <Form.Label>Status</Form.Label>
                 <Form.Select
                   value={frameData.status}
                   onChange={(e) => {
                     setFrameData(prev => ({ ...prev, status: e.target.value }));
                     updateFrameData(e.target.value, 'status');
                   }}
                 >
                   <option value="publish">Publish</option>
                   <option value="draft">Draft</option>
                 </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                 <Form.Label>Frame Image</Form.Label>
                 <Form.Control
                   type="file"
                   accept="image/*"
                   onChange={(e) => handleFileSelect(e, 'image')}
                   disabled={uploading}
                 />
                 {frameData.imageUrl && (
                   <div className="mt-2">
                     <ImageShow url={frameData.imageUrl} width={100} height={60} />
                   </div>
                 )}
               </Form.Group>
             </div>
             <div className="modal-footer">
               <Button 
                 variant="secondary"
                 onClick={() => setShowInfoModal(false)}
               >
                 Close
               </Button>
               <Button 
                 variant="primary"
                 onClick={() => saveFrame()}
               >
                 Save
               </Button>
             </div>
           </div>
         </div>
       )}

    </div>
  );
};

export default FrameEditor;
